import pretty from "Shared/pretty";
import { UploadMutationResTypes } from "Shared/types/UploadButton";
const dataExchangeFullName = (firstName: string, lastName: string) => {
  firstName = firstName ? firstName : "";
  lastName = lastName ? lastName : "";
  return lastName.toLowerCase() === "ether" ||
    firstName.toLowerCase() === "ether"
    ? "FTP"
    : pretty.fullName(firstName, lastName);
};

const getFileTypes = (mutationResponse: UploadMutationResTypes) => {
  let acceptTypes = ".csv, .xlsx, .xls";
  if (mutationResponse === "uploadPayrollJournal") {
    acceptTypes = `${acceptTypes}, .pdf`;
  }

  return { acceptTypes };
};

const Formatting = {
  dataExchangeFullName,
  getFileTypes,
};

export default Formatting;
